import { DEFAULT_TIMEZONE } from 'constants/timezone';

import dayjs from '../dayjs';

export default function getDefaultTimezone(defaultTimezone = DEFAULT_TIMEZONE) {
  return localStorage.getItem('time_zone') ?? defaultTimezone;
}

const userDateTime = () => {
  return dayjs().tz(getDefaultTimezone());
};

export { userDateTime };
